import React from 'react';
import styles from './ContactPerson.module.scss';

const ContactPerson: React.FC = () => {
  return (
    <div className={styles.contactPerson}>
      <p className={styles.title}>Sie können uns auch kontaktieren</p>
      <div className={styles.info}>
        <p className={styles.name}>FLEXXI Care Support Team</p>
        <a href="mailto:support@flexxi.care" className={styles.email}>
          support@flexxi.care
        </a>
        <a href="tel:+491724620874" className={styles.phone}>
          +49 172 4620874
        </a>
      </div>
    </div>
  );
};

export default ContactPerson;
